export class FiltroObterBilhetesSorteioConsumidor {
 
    public sorteioId: number;
 
    public consumidorId: number;
 
    public page: number;
 
    public pageSize: number;
}


// WEBPACK FOOTER //
// ./src/app/shared/model/filtro-obter-bilhetes-sorteio-consumidor.ts